import { ButtonLarge } from '../../components/Button';

type Props = {
    handlePrimaryAction: () => void;
    handleSecondaryAction: () => void;
    disabled?: boolean;
    primaryActionTitle?: string;
    secondaryActionTitle?: string;
};

export function ModalFooter({
    handlePrimaryAction,
    handleSecondaryAction,
    disabled = false,
    primaryActionTitle = 'Enregistrer',
    secondaryActionTitle = 'Annuler',
}: Props) {
    return (
        <div className="flex gap-9 mt-5">
            <ButtonLarge isPrimary={false} onClick={handleSecondaryAction}>
                {secondaryActionTitle}
            </ButtonLarge>
            <ButtonLarge onClick={handlePrimaryAction} disabled={disabled}>
                {primaryActionTitle}
            </ButtonLarge>
        </div>
    );
}
